export const defineLinksInString = (str: string) => {
  if (str) {
    const regex = /(www|http:|https:)[^ \n]+/g;
    return str.replace(regex, function (s, theWord) {
      return "<a href='"+s+"'>" + s + "</a>";
    });
  }
  return str;
};
